module.exports = __webpack_public_path__ + "img/gaston-berger.402cc2d9.png";